import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Box,
  Button,
  ListItem,
  List,
  ListItemButton,
  Autocomplete,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { FaUserGroup } from "react-icons/fa6";
import { FiUser } from "react-icons/fi";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import "./customer.scss";
import FormGroup from "@mui/material/FormGroup";
// import Textarea from "@mui/joy/Textarea";
import "./customer.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  addNewCustomer,
  editCustomer,
  fetchCustomerById,
} from "../../store/slices/Customer/thunk";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/esm/Spinner";
import { fetchCompany } from "../../store/slices/thunk";
import { GoogleMap, Marker, Autocomplete as GMapAutocomplete, useJsApiLoader, } from "@react-google-maps/api";
import { IoCalendarOutline, IoCloseOutline, IoSchoolOutline } from "react-icons/io5";
import { getTenantConfigFromStorage } from "../../helpers/tenantConfig";

const AddCustomer = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
    libraries: ["places", "geometry"]
  });
  const navigate = useNavigate();
  const [searchCompany, setSearchCompany] = React.useState("");

  const [addCustomer, setAddCustomer] = useState({
    name: "",
    mobile: "",
    email: "",
    address: {
      coordinates: [],
      type: "Point",
      streetAddress: "",
    },
    status: 'active',
    company: {
      companyId: "",
      companyName: "",
    },
    additionalInfo: [],
    _id: "",
  });
  const [childData, setChildData] = useState({
    childName: "",
    age: "",
    schoolName: "",
    gender: "male",
    rollNo: "",
  });

  const [mapSrc, setMapSrc] = useState("");
  const tenantConfig = getTenantConfigFromStorage();
  const parentLabel = tenantConfig.labels.parent;
  const schoolLabel = tenantConfig.labels.school;
  const { id } = useParams<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch: any = useDispatch();
  const [suggestions, setSuggestions] = useState([]);
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout | null>(
    null
  );
  const [allCompany, setAllCompany] = useState<any>([]);
  const [selectedPosition, setSelectedPosition] = useState<any>(null);
  const onLoadAutocomplete = (auto: any) => {
    setAutocomplete(auto);
  };
  const [autocomplete, setAutocomplete] = useState<any>(null);
  const [locationObject, setLocationObject] = useState<any>(null);
  //  useEffect(() => {
  //   const coords = addCustomer?.address?.coordinates;
  //   const isCoordsValid = coords && coords.length === 2;

  //   if (isCoordsValid) {
  //     const [lng, lat] = coords;

  //     // Only set if missing
  //     if (!addCustomer.address.streetAddress || !addCustomer.address.type) {
  //       setAddCustomer((prev) => ({
  //         ...prev,
  //         address: {
  //           ...prev.address,
  //           type: prev.address.type || 'Point',
  //           streetAddress: prev.address.streetAddress || 'China Town',
  //         },
  //       }));
  //     }

  //     // lng, lat should be used in correct order → lat, lng
  //     setMapSrc(`https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`);
  //   }
  // }, [
  //   addCustomer.address.coordinates[0],
  //   addCustomer.address.coordinates[1],
  // ]);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsEdit(true);
        const response: any = await dispatch(fetchCustomerById(id));
        const { name, mobile, email, address, status, company, _id, additionalInfo } = response.data;

        setAddCustomer({
          name,
          mobile,
          email,
          address,
          status,
          company,
          additionalInfo,
          _id,
        });
        setSelectedPosition({
          lat: response?.data?.address?.coordinates[1],
          lng: response?.data?.address?.coordinates[0]
        })
        setLocationObject({
          lat: response?.data?.address?.coordinates[1],
          lng: response?.data?.address?.coordinates[0],
          streetAddress: response?.data?.address?.streetAddress,
        });
        console.log(addCustomer);
        // navigate(`/editUser/${id}`);
      } else {
        setIsEdit(false);
        setAddCustomer({
          name: "",
          mobile: "",
          email: "",
          address: {
            coordinates: [],
            type: "Point",
            streetAddress: "",
          },
          status: 'active',
          company: {
            companyId: "",
            companyName: "",
          },
          additionalInfo: [],
          _id: "",
        });
        // navigate("/addUser");
      }
    };
    fetchData();
  }, [id, navigate, dispatch]);

  const handleSelectSuggestion = (place: any) => {
    setAddCustomer((prev: any) => ({
      ...prev,
      address: {
        type: "Point",
        streetAddress: place.display_name,
        coordinates: [parseFloat(place.lon), parseFloat(place.lat)],
      },
    }));
    setSuggestions([]); // hide list
  };
  const handleChildChange = (e: any) => {
    const { name, value } = e.target;
    setChildData({ ...childData, [name]: value });
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name.startsWith("address.")) {
      const field = name.split(".")[1];

      // normal field update
      setAddCustomer((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          [field]: value,
        },
      }));

      // agar streetAddress field hai, to suggestions fetch karo
      if (field === "streetAddress") {
        if (typingTimeout) clearTimeout(typingTimeout);

        const timeout = setTimeout(() => {
          if (value.trim().length > 2) {
            fetch(
              `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&countrycodes=pk&q=${encodeURIComponent(
                value
              )}`
            )
              .then((res) => res.json())
              .then((data) => {
                setSuggestions(data);
              })
              .catch((err) =>
                console.error("Error fetching suggestions:", err)
              );
          } else {
            setSuggestions([]);
          }
        }, 400); // debounce 400ms

        setTypingTimeout(timeout);
      }
    } else {
      setAddCustomer((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    const getAllCompany = async () => {
      const response: any = await dispatch(fetchCompany(1, 99999999, searchCompany, ''));
      if (response && response?.data?.data?.length > 0 && response?.isSuccess) {
        setAllCompany(response?.data?.data);
      } else {
        setAllCompany([]);
      }
      console.log(allCompany);
    };

    getAllCompany();
  }, [dispatch]);


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    console.log("Sending:", addCustomer);
    setLoading(true);

    try {
      if (isEdit) {
        if (
          addCustomer.address.streetAddress === "" ||
          addCustomer.email === "" ||
          addCustomer.mobile === "" ||
          addCustomer.name === "" ||
          addCustomer.status === ""
        ) {
          toast.error("Fill All Fields");
        } else {
          const res: any = await dispatch(editCustomer(addCustomer));
          if (res.data && res.isSuccess) {
            console.log("Success:", res);
            toast.success(`${parentLabel} Edited!`);
            navigate("/parent-list");
          } else {
            toast.error(`${parentLabel} Not Edit!`);
          }
        }
      } else {
        if (
          addCustomer.address.streetAddress === "" ||
          addCustomer.email === "" ||
          addCustomer.mobile === "" ||
          addCustomer.name === "" ||
          addCustomer.status === ""
        ) {
          toast.error("Fill All Fields");
        } else {
          const res: any = await dispatch(addNewCustomer(addCustomer));
          if (res.data && res.isSuccess) {
            console.log("Success:", res);
            toast.success(`${parentLabel} added!`);
            navigate("/parent-list");
          } else {
            toast.success(`${parentLabel} Not added!`);
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  const navigateTodcustomerList = () => {
    navigate("/parent-list");
  };
  const addChild = () => {
    if (!childData.childName || childData.age === "" || childData.schoolName === "" || childData.gender === "" || childData.rollNo === "") {
      return toast.error("Please fill all child fields");
    }

    setAddCustomer((prev: any) => ({
      ...prev,
      additionalInfo: [...(prev?.additionalInfo || []), childData],
    }));


    setChildData({
      childName: "",
      age: "",
      schoolName: "",
      gender: "male",
      rollNo: "",
    });
  };

  // remove child
  const removeChild = (index: number) => {
    setAddCustomer((prev) => ({
      ...prev,
      additionalInfo: prev.additionalInfo.filter((_, i) => i !== index),
    }));
  };
  const handleChangeForDriver = (e: any) => {
    const { value } = e.target;

    if (!value) {
      setAddCustomer({
        ...addCustomer,
        company: {
          companyId: "",
          companyName: "",
        },
      });
      return;
    }
    const selectedCompany: any = allCompany.find(
      (driver: any) => driver._id === value
    );

    if (selectedCompany) {
      setAddCustomer({
        ...addCustomer,
        company: {
          companyId: selectedCompany._id,
          companyName: selectedCompany.companyName,
        },
      });
    }
  };
  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();

      if (lat && lng) {
        setLocationObject({
          lat,
          lng,
          streetAddress: place.formatted_address || place.name || "",
        });
        setAddCustomer((prevData: any) => ({
          ...prevData,
          address: {
            streetAddress: place.formatted_address || place.name || "",
            coordinates: [lng, lat],
            type: 'Point'
          },
        }));
        setSelectedPosition({ lat, lng });
      }
    }
  };
  if (loadError) return <div>Map load error: {String(loadError)}</div>;
  if (!isLoaded) return <div>Loading Google Maps...</div>;
  return (
    <div className="boDy">
      <ToastContainer />
      {/* <div className="head">
        <h2>Add Customers</h2>
        <p>
          <span>Customers</span> / {      isEdit ? "Edit Customer" : "Add Customer"}
        </p>
      </div> */}
      <div
        className="box px-3 py-4"
        style={{ backgroundColor: "white", borderRadius: "12px", marginTop: "40px" }}
      >
        <div>
          <div className="d-flex justify-content-lg-between justify-content-start flex-column flex-lg-row flex-wrap">
            <h5 className="fw-bolder" style={{ color: "#1e90ff" }}>
              {isEdit ? `Edit ${parentLabel}` : `Add New ${parentLabel}`}
            </h5>
            <button
              type="button"
              onClick={navigateTodcustomerList}
              className="btn rounded-2"
              style={{ backgroundColor: "transparent", width: "fit-content" }}
            >
              <KeyboardBackspaceIcon />
              <span style={{ marginLeft: "10px" }}>Back To List</span>
            </button>
          </div>

        </div>
        <div className="row">
          <div className="col-md-12">
            <div
              className="box1222 px-3 py-3 mt-3"
              style={{ borderRadius: "12px", backgroundColor: "white" }}
            >
              <div className="row">
              <div className="col-md-6" style={{ marginBottom: "16px" }}>
                <h6>{parentLabel} Name <span style={{color:'red'}}>*</span></h6>
                <TextField
                  id="outlined-name"
                  fullWidth
                  placeholder={`${parentLabel} Name`}
                  name="name"
                  type="text"
                  value={addCustomer.name}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "42px",
                    },
                    "& .MuiInputBase-input": {
                      padding: "10px 14px",
                    },
                  }}
                />
              </div>

              <div className="col-md-6" style={{ marginBottom: "16px" }}>
                <h6>Email <span style={{color:'red'}}>*</span></h6>
                <TextField
                  id="outlined-email"
                  placeholder={`${parentLabel} Email`}
                  type="email"
                  name="email"
                  value={addCustomer.email}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "42px",
                    },
                    "& .MuiInputBase-input": {
                      padding: "10px 14px",
                    },
                  }}
                />
              </div>
              <div className="col-md-6" style={{ marginBottom: "16px" }}>
                <h6>Contact Number <span style={{color:'red'}}>*</span></h6>
                <TextField
                  id="outlined-mobile"
                  placeholder={`${parentLabel} Mobile`}
                  name="mobile"
                  type="text"
                  value={addCustomer.mobile}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "42px",
                    },
                    "& .MuiInputBase-input": {
                      padding: "10px 14px",
                    },
                  }}
                />
              </div>
              <div className="col-md-6" style={{ marginBottom: "16px" }}>
                <h6>{schoolLabel} <span style={{color:'red'}}>*</span></h6>
                <Box>
                  <Autocomplete
                    options={allCompany}
                    getOptionLabel={(option: any) => option.companyName}
                    value={
                      allCompany.find(
                        (v: any) => v._id === addCustomer.company?.companyId
                      ) || null
                    }
                    onInputChange={(event, newInputValue) => {
                      setSearchCompany(newInputValue);
                    }}
                    onChange={(event, newValue: any) => {
                      handleChangeForDriver({
                        target: { value: newValue ? newValue._id : "" },
                      });
                    }}
                    clearOnEscape
                    ListboxProps={{
                      sx: {
                        backgroundColor: "#fff",
                        color: "#000",
                        "& .MuiAutocomplete-option": {
                          color: "#000",
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={`Search or Select ${schoolLabel}`}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "42px",
                            padding: "0 14px",
                          },
                          "& .MuiInputBase-input": {
                            padding: "10px 0 !important",
                          },
                          "& .MuiInputLabel-root": {
                            transform: "translate(14px, 11px) scale(1)",
                          },
                          "& .MuiInputLabel-shrink": {
                            transform: "translate(0, -6px) scale(0.75)",
                          },
                        }}
                      />
                    )}
                  />
                </Box>
              </div>
              <div className="col-md-6" style={{ marginBottom: "16px" }}>
                <h6>Status <span style={{color:'red'}}>*</span></h6>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  onChange={handleChange}
                  name="status"
                  style={{ height: "42px", padding: "10px 14px", fontSize: "14px" }}
                >
                  <option value='active'>Active</option>
                  <option value="inActive">Inactive</option>
                </select>
              </div>
              </div>
              {/* <div className="col-md-12 mt-3"> */}
              <h6>Address <span style={{color:'red'}}>*</span></h6>
              {/* <TextField
                  placeholder="Type to Search Address"
                  multiline
                  name="address.streetAddress"
                  value={addCustomer.address.streetAddress}
                  onChange={handleChange}
                  type="text"
                  rows={2}
                  fullWidth
                />

                {suggestions.length > 0 && (
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      maxHeight: "200px",
                      overflow: "auto",
                      background: "#fff",
                      zIndex: 10,
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    {suggestions.map((place: any, idx) => (
                      <div
                        key={idx}
                        style={{
                          padding: "8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onClick={() => handleSelectSuggestion(place)}
                      >
                        {place.display_name}
                      </div>
                    ))}
                  </div>
                )}

                {addCustomer.address.coordinates[1] &&
                  addCustomer.address.coordinates[0] && (
                    <iframe
                      className="mt-3"
                      title="map"
                      src={`https://www.openstreetmap.org/export/embed.html?bbox=${addCustomer.address.coordinates[0]}%2C${addCustomer.address.coordinates[1]}%2C${addCustomer.address.coordinates[0]}%2C${addCustomer.address.coordinates[1]}&layer=mapnik&marker=${addCustomer.address.coordinates[1]}%2C${addCustomer.address.coordinates[0]}`}
                      height="300"
                      style={{
                        border: 0,
                        marginTop: "12px",
                        width: "-webkit-fill-available",
                      }}
                    ></iframe>
                  )} */}

              {/* <div className="mt-3">
        <p><strong>Lat:</strong> {addCustomer.address.coordinates[1]}</p>
        <p><strong>Lng:</strong> {addCustomer.address.coordinates[0]}</p>
      </div> */}
              {/* </div> */}
              {/* <div className="col-md-12 mt-3">
                <h6>Selected Location</h6>
                <div
                  className="box1231 rounded-3 p-3"
                  style={{
                    backgroundColor: "#F0FDF4",
                    border: "1px solid #BBF7D0",
                  }}
                >
                  <h6 style={{ color: "#065F46" }}>
                    <span style={{ color: "#16A34A" }}>
                      <LocationOnIcon />
                    </span>{" "}
                    {addCustomer.address.streetAddress ||
                      "No location selected"}
                  </h6>
                  <span style={{ color: "#16A34A" }}>
                    COORDINATATES:{addCustomer.address.coordinates[1] || "--"},{" "}
                    {addCustomer.address.coordinates[0] || "--"}
                  </span>
                </div>
              </div> */}

              <GMapAutocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}
                options={{
                  componentRestrictions: { country: "pk" },
                  types: ['geocode', 'establishment'],
                  fields: ['address_components', 'geometry', 'icon', 'name', 'formatted_address']
                }}
              >
                <input
                  type="text"
                  placeholder="Search location..."
                  value={locationObject?.streetAddress}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "") {
                      setLocationObject(null);
                      setSelectedPosition(null);
                    } else {
                      setLocationObject((prev: any) => ({
                        ...prev,
                        streetAddress: value,
                      }));
                    }
                  }}
                  style={{
                    width: "100%",
                    height: "40px",
                    marginBottom: "10px",
                    padding: "0 10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                  }}
                />
              </GMapAutocomplete>
              <GoogleMap

                center={selectedPosition || { lat: 24.8607, lng: 67.0011 }} // default Karachi
                zoom={selectedPosition ? 14 : 10}
                mapContainerStyle={{ width: "100%", height: "300px" }}
              >
                {/* Selected marker */}
                {selectedPosition && <Marker position={selectedPosition} />}
              </GoogleMap>
            </div>
          </div>
          <div className="d-flex flex-column gap-4">
            {/* <div className="d-flex flex-column ">
              <input
                type="text"
                name="childName"
                placeholder="Child Name"
                value={childData.childName}
                onChange={handleChildChange}
              />
              <input
                type="number"
                name="age"
                placeholder="Age"
                value={childData.age}
                onChange={handleChildChange}
              />
              <input
                type="text"
                name="schoolName"
                placeholder="School Name"
                value={childData.schoolName}
                onChange={handleChildChange}
              />
              <input
                type="text"
                name="gender"
                placeholder="Gender"
                value={childData.gender}
                onChange={handleChildChange}
              />
              <input
                type="date"
                name="birthOfDate"
                value={childData.birthOfDate}
                onChange={handleChildChange}
              />
            </div> */}


            {/* <div className="ChildrenBox">
              <div className="d-flex gap-3 align-items-center">
                <div className="UserIcon">
                  <FaUserGroup />
                </div>
                <h1>Children Management</h1>
              </div>
              <p className="AddInfotrmation">Add and manage children information</p>
            </div> */}
            {/* <div className="AddNewChildrenBox">
              <div className="d-flex align-items-baseline gap-3">
                <div className="UserIcon"><FiUser /></div>
                <h4>Add New Children</h4>
              </div>
              <div className="InputFields">
                <div className="d-flex flex-column">
                  <p className="Name">Child Name</p>
                  <input type="text" name="childName"
                    className="input" value={childData.childName}
                    onChange={handleChildChange} placeholder="Enter Name..." />
                </div>

                <div className="d-flex flex-column">
                  <p className="Name">Age</p>
                  <input
                    placeholder="Enter age..."
                    type="number" name="age"

                    className="input"
                    value={childData.age}
                    onChange={handleChildChange}
                  />
                </div>

                <div className="d-flex flex-column">
                  <p className="Name">School Name</p>
                  <input type="text" name="schoolName"
                    className="input" value={childData.schoolName}
                    onChange={handleChildChange} placeholder="Enter School Name..." />
                </div>

                <div className="d-flex flex-column">
                  <p className="Name"> Gender</p>
                  <select className="input" name="gender"
                    value={childData.gender}
                    onChange={handleChildChange}>
                    <option value="male">Male</option>
                    <option value="feMale">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="d-flex flex-column">
                  <p className="Name">Roll No</p>
                  <input type="text" className="input" name="rollNo"
                    value={childData.rollNo}
                    onChange={handleChildChange} placeholder="Enter Roll No..." />
                  <button className="AddChild mt-4" onClick={addChild}>Add Child</button>
                </div>
              </div>
            </div>
            {addCustomer?.additionalInfo?.length > 0 &&
              <h4 className="Title">
                <IoCalendarOutline className="TitleIcon" /> Children Added ({addCustomer?.additionalInfo?.length})
              </h4>
            }
            {addCustomer?.additionalInfo?.length > 0 && <div className="ChildrenBox">
              {addCustomer?.additionalInfo?.map((child: any, index) => (
                <div className="ChildCard">
                  <div className="Header">
                    <div className="Info">
                      <h5 className="Name">{child?.childName}</h5>
                      <span className="Gender">{child?.gender == 'male' ? 'Male' : child.gender == 'feMale' ? 'Female' : child.gender == 'other' ? 'Other' : ''}</span>
                    </div>

                    <IoCloseOutline onClick={() => removeChild(index)} className="CloseIcon" />
                  </div>

                  <div className="Details">
                    <p className="Row">
                      <IoCalendarOutline className="Icon" /> <strong>Age:</strong> {child?.age} years
                    </p>
                    <p className="Row">
                      <IoSchoolOutline className="Icon" />{" "}
                      <strong>School:</strong> {child?.schoolName}
                    </p>
                    <p className="Row">
                      <IoCalendarOutline className="Icon" />{" "}
                      <strong>Roll No:</strong> {child?.rollNo}
                    </p>
                  </div>
                </div>
              ))}
            </div>} */}


          </div>



          {/* <ul>
            {addCustomer.additionalInfo.map((child: any, index) => (
              <li key={index}>
                {child.childName} ({child.age} years) – {child.schoolName} –{" "}
                {child.gender} – {child.birthOfDate}
                <button onClick={() => removeChild(index)}>❌ Remove</button>
              </li>
            ))}
          </ul> */}
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="mt-4 aDD" style={{ backgroundColor: "transparent" }}>
                  <Button onClick={handleSubmit} disabled={loading} style={{ textTransform: "none", fontWeight: "600", width: "auto",backgroundColor:"#2563EB" }}  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        {isEdit ? "Edit..." : "Add..."}
                      </>
                    ) : (
                      isEdit ? `Edit ${parentLabel}` : `Add ${parentLabel}`
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCustomer;
